import React from 'react'
import LandingBody from '../components/body/LandingBody';

const LandingPage = () => {
    return (
        <React.Fragment>
            <LandingBody />
        </React.Fragment>
    )
};

export default LandingPage;